import * as orderSubmission from '../../services/order-submission.js';

export default () => ({
    checkout: {
        failed: { data: { messages: [], next_url: null, status: '' }, status: false },
        placementStage: 'finalising',
        session: null,
    },

    order: { placed: true },

    init() {
        this.checkout.session = window.Gifted.checkoutSession;

        orderSubmission.awaitOrderCreation(this.checkout.session.id, {
            onComplete: (session) => {
                window.location.pathname = new URL(session.redirect_url).pathname;
            },
            onFailed: (data) => {
                this.order.placed = false;
                this.checkout.failed = { data, status: true };
            },
        });
    },
});
